<template>
  <div class="progress-card" >
    <div class="header">
      <span>{{ title }}</span>
      <h2 :style="{ color: color }">{{ current }}</h2>
    </div>

    <div class="progress">
      <div
        class="progress-fill"
        :style="{
          width: percentage + '%',
          backgroundColor: color
        }"
      ></div>
    </div>

    <div class="footer">
      <span>من {{ total }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "ProgressCard",

  props: {
    title: {
      type: String,
      required: true,
    },
    current: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    color: {
      type: String,
      default: "#3844C8",
    },
  },

  computed: {
    percentage() {
      if (this.total === 0) return 0;
      return Math.min((this.current / this.total) * 100, 100);
    },
  },
};
</script>

<style scoped>
.progress-card {
  background: #fff;
  border: 1px solid #e5e9f8;
  border-radius: 22px;
  padding: 14px;
  /* height: 190px; */
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header h2 {
  font-size: 28px;
  margin: 0;
  font-weight: 700;
}

.header span {
  color: #7A7060;
  /* font-size: 24px; */
  font-weight: 600;
}

.progress {
  margin-top: 22px;
  height: 10px;
  background: #e8edf3;
  border-radius: 20px;
  overflow: hidden;
  direction: ltr;
}

.progress-fill {
  height: 100%;
  border-radius: 20px;
  transition: width .5s ease;
}

.footer {
  margin-top: 20px;
  text-align: right;
  color: #999;
  /* font-size: 20px; */
  font-weight: 600;
}
</style>